import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(undefined, "europe-west1");

export const createMembershipCheckoutSession = httpsCallable<
  { membershipPlanId: string; origin: string },
  { sessionId: string; url: string | null }
>(functions, "createMembershipCheckoutSession");

export const createPaygCheckoutSession = httpsCallable<
  {
    classId: string;
    guestEmail: string;
    guestName: string;
    guestDateOfBirth: string;
    guestPhone: string;
    origin: string;
  },
  { sessionId: string; url: string | null }
>(functions, "createPaygCheckoutSession");

export const createCustomerPortalSession = httpsCallable<
  { origin: string },
  { url: string }
>(functions, "createCustomerPortalSession");

export const getMyBillingState = httpsCallable<
  Record<string, never>,
  {
    user: {
      billingStatus: string;
      appAccessStatus: string;
      activeEntitlementId: string | null;
      activeMembershipPlanId: string | null;
      membershipCurrentPeriodEnd: unknown;
    };
    entitlements: Array<Record<string, unknown>>;
  }
>(functions, "getMyBillingState");

export const getPublicMembershipPlans = httpsCallable<
  Record<string, never>,
  {
    plans: Array<{
      id: string;
      gymId: string;
      name: string;
      slug: string;
      tierCode: string;
      interval: "month" | "year";
      appAccess: "none" | "limited" | "full";
      bookingPolicy: {
        canBookClasses: boolean;
        allowedClassTags: string[];
        weeklyBookingLimit: number | null;
      };
      stripePriceId: string;
    }>;
  }
>(functions, "getPublicMembershipPlans");

export const getPublicPaygClasses = httpsCallable<
  Record<string, never>,
  {
    classes: Array<{
      id: string;
      title: string;
      timezone: string;
      startTime: { seconds: number; nanoseconds: number };
      endTime?: { seconds: number; nanoseconds: number };
      coachName: string;
      location: string;
      capacity: number;
      bookedCount: number;
      paygPriceMinor: number;
      paygProductName: string;
    }>;
  }
>(functions, "getPublicPaygClasses");
